import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router, syncThemeColorByRoute } from './router'
import { appConfig } from './config'
import { demoTrace, initDevTrace } from './utils/devTrace'
import './styles/index.scss'

initDevTrace({
  openApiBaseUrl: appConfig.openApiBaseUrl,
  wsUrl: appConfig.wsUrl,
  defaultMobileMode: appConfig.defaultMobileMode,
  defaultDesktopMode: appConfig.defaultDesktopMode,
  protocolVersion: appConfig.defaultProtocolVersion,
  logicalDeviceId: appConfig.defaultLogicalDeviceId,
  frameDurationMs: appConfig.defaultFrameDurationMs,
  mcpEnabled: appConfig.mcpEnabledDefault,
})

// UA 单独记一条，紧跟 boot 日志，便于真机排查浏览器识别问题
// （搜狗/QQ 等套壳浏览器 UA 特征核对）。访问 URL 带 ?inmote=xw 即可在日志看到。
demoTrace('ua', navigator.userAgent)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')

router.isReady().then(() => {
  // 兜底：首屏直达某个路由时，也要立即同步浏览器主题色。
  syncThemeColorByRoute(router.currentRoute.value)
})
